// ** React Imports
import ReactDOM from "react-dom"
import { Suspense, lazy } from "react"
import { BrowserRouter } from "react-router-dom"

// ** Redux Imports
import { store } from "./redux/store"
import { Provider } from "react-redux"

// ** Amplfiy config
import { Amplify, Storage, API } from "aws-amplify"
import { awsmobile } from "./aws-cfg"
// ** ThemeColors Context

import { ThemeContext } from "./utility/context/ThemeColors"

// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner"

import TransProvider from "@contexts/intl/Internationalization"
import ToastHost from "@components/toast/ToastHost"

// ** Ripple Button
import "./@core/components/ripple-button"

// ** PrismJS
import "prismjs"
import "prismjs/themes/prism-tomorrow.css"
import "prismjs/components/prism-jsx.min"

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css"

// ** React Hot Toast Styles
import "@styles/react/libs/react-hot-toasts/react-hot-toasts.scss"

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css"
import "./@core/scss/core.scss"
import "./assets/scss/style.scss"
import { stopReportingRuntimeErrors } from "react-error-overlay"

if (process.env.NODE_ENV === "development") {
  stopReportingRuntimeErrors() // disables error overlays
}
// ** Service Worker
import * as serviceWorker from "./serviceWorker"

Amplify.configure(awsmobile)
// Auth.configure(awsmobile)
// Storage.configure(awsmobile)
// ** Lazy load app
const LazyApp = lazy(() => import("./App"))
ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <Suspense fallback={<Spinner />}>
        <ThemeContext>
          <TransProvider>
            <LazyApp />
            <ToastHost />
          </TransProvider>
        </ThemeContext>
      </Suspense>
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
